module.exports = __webpack_public_path__ + "static/Team1-64e6bff6c2218d14d404a001119f4625.png";